export function scrollToElement(elt, {dx, dy}) {
    const rect = elt.getBoundingClientRect();
    const x = rect.left + dx + window.scrollX;
    const y = rect.top + dy + window.scrollY;
    window.scrollTo({top: y, left: x, behavior: "smooth"});
}
